export default __webpack_public_path__ + "static/media/Background_placeholder.4d5c9cba.jpg";